import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SubclienteMonto } from '../../cliente/subclienteMonto.model';
import { Subcliente } from '../../cliente/subcliente.model';
import { BackendService } from '../../core/backend.service';
import { SnackService } from '../../shared-services/snack.service';
import { NavigationService } from '../../shared-services/navigation.service';
import { ApiService } from '../../core/api.service';
import { DialogService } from '../../shared-components/modals/dialog.service';
import { Parametric } from '../../cliente/parametric.model';
import { Acuerdo } from '../acuerdo.model';

@Component({
  selector: 'app-acuerdo-user-monto-max',
  templateUrl: './acuerdo-user-monto-max.component.html',
  styleUrls: ['./acuerdo-user-monto-max.component.scss']
})
export class AcuerdoUserMontoMaxComponent implements OnInit {

  acuerdo: any;
  subclientesMonto: SubclienteMonto[] = [];
  tipoLimites: Parametric[];

  totalItems: any;
  isLoading: any;

  onPageChange(any) {}

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private backendService: BackendService,
    private snackService: SnackService,
    private navigationService: NavigationService,
    private apiService: ApiService,
    private dialogService: DialogService,
  ) { }

    async ngOnInit() {
    this.route.data.subscribe(data => {
      this.acuerdo = data.acuerdo;
    });
    await this.getMontosSubclientes();
    await this.getTiposLimiteMontoCompra();
  }

  async getMontosSubclientes() {
    // tslint:disable-next-line:max-line-length
    await this.backendService.get(SubclienteMonto, Subcliente.path + 'allByAcuerdo/' + this.acuerdo.id, null).toPromise().then(value => {
       this.subclientesMonto = value as SubclienteMonto[];
    });
  }

  async getTiposLimiteMontoCompra() {
    this.tipoLimites = await this.apiService.get(Parametric, Parametric.path + 'tipos_limite_montos_compra/', null).toPromise();
  }

  back() {
    this.router.navigate(['/acuerdos/detalles/' + this.acuerdo.id]);
  }

  confirmSave() {
    this.dialogService.confirm(
    '¿Está seguro que desea guardar los cambios?')
    .then( res => {
      if (res) {
        this.saveSubclientesMontos(res);
      }
    });
  }

  async saveSubclientesMontos(res) {

    if (res) {

      this.snackService.spinner(true);

      try {

      await this.backendService.update(Subcliente.path + 'save-monto-max-acuerdo', this.subclientesMonto);
      this.router.navigate(['/acuerdos/detalles/' + this.acuerdo.id]);
      this.snackService.success('Usuarios editados satisfactoriamente');

      } catch (ex) {
          if (ex[0]) {
          this.snackService.error(ex[0].details);
          } else if (ex.errors) {
            this.snackService.error(ex.errors[0].defaultMessage);
            } else {
            this.snackService.error(ex.message);
            }
          } finally {
            this.snackService.spinner(false);
          }
      }
    }

getChecked(event: any, index: number) {
  this.subclientesMonto[index].idMontoMax = event.value;
}
}



// WEBPACK FOOTER //
// ./src/app/acuerdo/acuerdo-user-monto-max/acuerdo-user-monto-max.component.ts